// @flow
import api from 'tim-api';
import { visits as visitsEndPoint } from 'endPoints';
import moment from 'moment';

const date = moment().add(1, 'days').format('YYYY-MM-DD');


export const state: Object = {
  visits: [],
  pagination: {}
};

export const getters = {
  visits: (state: Object) => state.visits,
  getVisitId: (state: Object) => (id: Number) => id && state.visits.find(visit => visit.id === id),
  pagination: (state: Object) => state.pagination
};

export const mutations = {
  SET_VISITS(state: Object, visits: Array<Object>) {
    state.visits = visits;
  },
  SET_PAGINATION(state: Object, pagination: Object) {
    state.pagination = pagination;
  },
  SET_VISIT(state: Object, payload: Object) {
    state.visit = {
      ...state.visit,
      ...payload
    };
  }
};


export const actions = {
  fetchVisitsNext({ commit }: Action) {
    return api.get(`${visitsEndPoint}?paginate=true`).then(({ data }) => {
      commit('SET_VISITS', data.data);
      commit('SET_PAGINATION', {
        current_page: data.current_page,
        first_page_url: data.first_page_url,
        from: data.from,
        last_page: data.last_page,
        last_page_url: data.last_page_url,
        next_page_url: data.next_page_url,
        path: data.path,
        per_page: data.per_page,
        prev_page_url: data.prev_page_url,
        total: data.total

      });
    });
  },

  // eslint-disable-next-line
  sendVisit({ commit }: Action, visit: Object) {
    return api.post(visitsEndPoint, visit);
  },
  setVisit({ commit }: Action, payload: Object) {
    commit('SET_VISIT', payload);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
